module.exports = __webpack_public_path__ + "img/badge-list-thumb-070.d53df688.png";